import { dependencies } from './workflow.dependency';
import { PrimitiveType } from './workflow.type';

export interface ValueLabelItem {
  id?: number;
  value: PrimitiveType;
  label: string;
}

/**
 * An item in an enumeration
 * Should expose value, human readable label (or fallback to value), and information on savability (e.g. whether it's virtual/UI-only
 * or something that exists on the API)
 */
export class EnumerationItem implements ValueLabelItem {
  constructor(public readonly enumId: string, protected _value: PrimitiveType, public readonly virtual = false) {
    if (typeof _value !== 'string' && typeof _value !== 'number' && typeof _value !== 'boolean') {
      throw new Error(`Invalid value on enum "${enumId}": ${_value}`);
    }
  }

  /**
   * Human readable label from dictionary (or fallback to value)
   */
  public get label(): string {
    const valueString = this.value == null ? '' : String(this.value);
    const dictionarySegment = dependencies.dictionaryService.readSegment('enum', this.enumId, valueString);
    return typeof dictionarySegment === 'string'
      ? <string>dependencies.stringVariableService.parse(dictionarySegment)
      : <string>dependencies.stringVariableService.parse(valueString);
  }

  public get value(): PrimitiveType {
    // eslint-disable-next-line no-underscore-dangle
    return this._value;
  }

  public set value(v: PrimitiveType) {
    // eslint-disable-next-line no-underscore-dangle
    this._value = v;
  }
}
